var _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreeGreenDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 384,
    height: 406,
    viewBox: "0 0 384 406",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256.5,
    cy: 17.5,
    r: 17.5,
    fill: "#43912A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 322.5,
    r: 17.5,
    fill: "#43912A"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 366.5,
    cy: 388.5,
    r: 17.5,
    fill: "#43912A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeGreenDots);
export default __webpack_public_path__ + "static/media/ThreeGreenDots.accd143887d721495e3a0d662b772b5a.svg";
export { ForwardRef as ReactComponent };